import React, { useState } from "react";
import { Link } from "react-router-dom";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import CloseIcon from "@mui/icons-material/Close";
import ActivityBar from "../../components/Reusable/ActivityBar/ActivityBar";
import Styles from "../../Views/Operations/BusinessDescription/BusinessDescription.module.css";
import CardImg1 from "../.././assets/images/knowledge_cardimg1.png"
import CardImg2 from "../.././assets/images/knowledge_cardimg2.png"
import ActivityStyle from "../ActivityBible/activity.module.css"
import { sections, sectionPaths } from "../.../../../constants/sectionData";

import {
    Box,
    Paper,
    Typography,
  
  } from "@mui/material";
import SectionSlider from "../Reusable/SectionSlider/SectionSlider";

const KnowledgeManagement: React.FC = () => {
  const management = localStorage.getItem("management") || "Default Location Name";

    const [activeSection, setActiveSection] = useState(2);
  
    const handleNextSection = () => {
        setActiveSection((prev) => (prev + 1) % sections.length);
      };
    
    const handlePrevSection = () => {
        setActiveSection((prev) => (prev - 1 + sections.length) % sections.length);
      };
const breadcrumbs = [
     <Link key="1" color="#000" to="/">
          Home
        </Link>,
        <Link key="2" color="#000" to="/operations/management">
          Evidence Upload
        </Link>,
        <Link key="3" color="#000" to="/operations/management">
          Management
        </Link>,
    <Typography key="4">{management}</Typography>,
  ];

    return(
        <>
               {/* <ActivityBar breadcrumbs={breadcrumbs} />
   <div className={Styles.mainContent}>
        <div className={Styles.topTabBar}>
          <div className={Styles.navigateTabBar}>
            <ArrowBackIosNewIcon onClick={handlePrevSection} />
          </div>
          <div className={Styles.tabBarNavigation}>
            {sections.map((section, index) => (
              <div key={index}>
                <p
                  className={
                    index === activeSection ? Styles.activeTab : Styles.topbarTabs
                  }
                  onClick={() => setActiveSection(index)}
                >
                  {section}
                </p>
                <hr />
              </div>
            ))}
          </div>
          <div className={Styles.navigateTabBar}>
            <ArrowForwardIosIcon onClick={handleNextSection} />
          </div>
        </div>
      </div> */}

<ActivityBar breadcrumbs={breadcrumbs} />
      <SectionSlider
        sections={sections}
        sectionPaths={sectionPaths}
        highlightSection={"Standards Creation & Execution"}
        highlightColor="#D7A833"
        defaultColor="#666"
      />
   <Box sx={{ display: "flex", gap:1, }}>
      <Box className={ActivityStyle.biblecard} sx={{ maxWidth: 350, m:2 }}>
      <Box className={ActivityStyle.cardImgcontent}>
       <img className={ActivityStyle.cardimg} src={CardImg1} />
       <Box  className={ActivityStyle.Imgtext}>
       <h3>Service Now</h3>
       </Box>
       </Box>
        <Box>
          <Typography gutterBottom variant="h5" component="div">
            <a href="https://abinbevww.service-now.com/$knowledge.do?sysparm_type_filter=all&sysparm_kb=39aab365c363c21013c9f5cf05013121&sysparm_category=484bd06ec32cd610fd2c27f9d0013131&browse_type=categories"
             target="_blank" className={ActivityStyle.biblecardbutton}>View</a>
          </Typography>
         
        </Box>
      </Box>

      <Box className={ActivityStyle.biblecard} sx={{ maxWidth: 350, m:2, ml:0 }}>
      <Box className={ActivityStyle.cardImgcontent}>
       <img className={ActivityStyle.cardimg} src={CardImg2} />
       <Box  className={ActivityStyle.Imgtext}>
       <h3>ACADIA</h3>
       </Box>
       </Box>
        <Box>
          <Typography gutterBottom variant="h5" component="div">
            <a href="https://ab-inbev.acadia.sysalli.com/browse" target="_blank" className={ActivityStyle.biblecardbutton}>View</a>
          </Typography>
         
        </Box>
      </Box>
      </Box>
        </>
    )
}
    export default KnowledgeManagement;
